import React from "react";

export function AccessingPHIDisclaimer() {
  return (
    <div className="tw:text-white tw:rounded-full tw:bg-fill-primary tw:px-4 tw:py-1 tw:text-text-white tw:print:hidden">
      You are now accessing protected health information and access is being logged.
    </div>
  );
}
